module.exports = __webpack_public_path__ + "img/illustration-project-empty-state@2x.3e0240c9.png";